import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import MaldivesRetreat2025 from './MaldivesRetreat2025';
import HimalayasRetreat2026 from './HimalayasRetreat2026';
import RetreatRegistrationForm from './RetreatRegistrationForm';
import HimalayasRegistrationForm from './HimalayasRegistrationForm';



function App() {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/maldives-retreat" element={<MaldivesRetreat2025 />} />
        <Route path="/register" element={<RetreatRegistrationForm />} />

        <Route path="/himalayas-retreat" element={<HimalayasRetreat2026 />} />
        <Route path="/himalayas-register" element={<HimalayasRegistrationForm />} />
      </Routes>
    </Router>
  );
}

export default App;
